export const engInfo = {
    Titles:{
        about:"ABOUT ME", 
        technologies:"STACK", 
        projects:"PROJECTS",
        contact:"CONTACT"
    },
    Form:{
        name:"Name",
        email:"your@email.com",
        message:"Your message..."
    }
}

export const spaInfo = {
    Titles:{
        about:"SOBRE MI", 
        technologies:"TECNOLOGÍAS", 
        projects:"PROYECTOS",
        contact:"CONTACTO"
    },
    Form:{
        name:"Nombre",
        email:"ejemplo@email.com",
        message:"Tu mensaje..."
    }
}